/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { Box, Button, Grid, Paper, Tab, Tabs, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { Star } from '@material-ui/icons'
import PropTypes from 'prop-types'
import React, { useContext, useMemo } from 'react'
import { ArrowLeft, ArrowRight, Clock, Info } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import ExcelLogo from '../../../../../assets/images/learnstage-logo.png'
import UploadImg from '../../../../../assets/images/upload-logo.png'
import RouterContext from '../../../../../contexts/route.context'
import { PROGRAM_TYPE, ROUTES } from '../../../../../helpers/constants'
import { getSchoolUrl, isEmpty, isNullOrEmpty, noop } from '../../../../../helpers/utils'
import withRedirect from '../../../../../hocs/RedirectHOC'
import Breadcrumb from '../../../../breadcrumbs/SimpleBreadcrumbs'
import useStyles from '../../allEnrollments/ProgramCourses.Style'
import AddOnProgramDetail from './AddOnProgramDetail'
import AddOnPrograms from './AddOnPrograms'
import AddOnPurchaseItems from './AddOnPurchaseItems'
import AgeRequirement from './AgeRequirment'
import CareerForm from './CareerInstructionForm'
import CoursesList from './CoursesList'
import TermsConditions from './TermsConditions'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <>{children}</>}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function AvailableProgramDetail({
  allHeadCells,
  programDetail,
  enrollCourse,
  ageRequirement,
  toggleAgeRequirementModal,
  termCondition,
  value,
  handleChange,
  school,
  readOnlyMode,
  enrollProgram,
  careerInstructionQuestion,
  setCareerInstructionQuestion,
  careerInstructionFormUgly,
  handleRuleValidation,
  user,
  courseList,
  setCourseList,
  programRatings,
  programReviewSettings,
  addOnsList,
  selectedAddOnItems,
  setSelectedAddOnItems,
  attachedProgramDetail,
  addOnProgramQuestions,
  addOnProgramRatings,
  addOnProgramReviewSettings,
  setAttachedProgramCoursesList,
  attachedProgramCoursesList,
  setAddOnProgramQuestions,
  saveAddOnProgram,
  addOnProgramDetailToggle,
  addOnProgramDetail,
  addOnProgramSaved,
  removeAddOnProgram,
  addOnProgramTabValue,
  handleAddOnProgramTabChange,
  addOnProgramQuestionsUgly,
  programMetaData,
  metadata,
}) {
  const classes = useStyles()
  const { t } = useTranslation()
  const history = useHistory()
  const { params } = useContext(RouterContext)
  const [selectedGrade, setSelectedGrade] = React.useState('')
  const [selectedGradeAddOnProgram, setSelectedGradeAddOnProgram] = React.useState('')
  const [answerTextError, setAnswerTextError] = React.useState('')

  const toggleCurrentGrade = (e) => {
    setSelectedGrade(e.target.value)
    const updatedCourseList = programDetail?.pgm_program_course_group.map((cg) => ({
      ...cg,
      cg_course_group_item: cg.cg_course_group_item.filter((cgi) =>
        programDetail.pgm_init_courses_regular === 'default'
          ? isNullOrEmpty(cgi.cgi_grade_level)
          : cgi.cgi_grade_level === e.target.value || isNullOrEmpty(cgi.cgi_grade_level)
      ),
    }))

    setCourseList(updatedCourseList)
  }

  const toggleGradeAddOnProgram = (e) => {
    setSelectedGradeAddOnProgram(e.target.value)
    if (!isEmpty(attachedProgramDetail)) {
      const attachedProgramCourseList = attachedProgramDetail?.pgm_program_course_group.map(
        (cg) => ({
          ...cg,
          cg_course_group_item: cg.cg_course_group_item.filter((cgi) =>
            attachedProgramDetail.pgm_init_courses_regular === 'default'
              ? isNullOrEmpty(cgi.cgi_grade_level)
              : cgi.cgi_grade_level === e.target.value || isNullOrEmpty(cgi.cgi_grade_level)
          ),
        })
      )
      setAttachedProgramCoursesList(attachedProgramCourseList)
    }
  }

  const breadcrumbData = [
    {
      title: t('breadcrumbSIS'),
      href: ROUTES.DASHBOARD,
    },
    {
      title: t('otherPrograms'),
      href: ROUTES.PROGRAMCOURSES,
    },
    {
      title: t('programsDetails'),
      href: '',
    },
  ]

  const theme = useTheme()
  const [termsCondition, setTermsCondition] = React.useState(false)
  const [addOnsModal, setAddOnsModal] = React.useState(false)
  const toggleTermsConditionModal = (clickType = '') => {
    if (!termsCondition && !handleRuleValidation()) {
      return
    }
    if (addOnsModal) {
      setAddOnsModal(false)
    }
    if (!clickType === 'proceedClick' && selectedAddOnItems?.length) {
      setSelectedAddOnItems([])
    }
    setTermsCondition(!termsCondition)
    if (addOnProgramDetail) {
      setAddOnProgramDetail(!addOnProgramDetail)
    }
  }

  const toggleAddOnItemsModal = () => {
    if (programMetaData?.skip_psm_gateways) {
      toggleTermsConditionModal()
      return
    }
    setAddOnsModal(!addOnsModal)
    if (selectedAddOnItems?.length) {
      // setSelectedAddOnItems([])
    }
  }
  const breakpoint = useMediaQuery('(max-width:599px)')
  const ButtonEnhanced = withRedirect(Button)

  const isApplicationQustionFilled = useMemo(() => {
    return careerInstructionQuestion?.every((items) =>
      items.pq_question_type === 'radio'
        ? items.pq_question_option.some((que) => que.enable === 'true')
        : items.pq_question_type === 'checkbox'
        ? items.pq_question_option.some((que) => que.enable === true)
        : items.pq_question_type === 'text'
        ? !isEmpty(items.pqr_answer_text)
        : false
    )
  }, [careerInstructionQuestion])

  React.useEffect(() => {
    if (!isEmpty(programDetail) && programDetail.pgm_is_college_program) {
      setSelectedGrade(programDetail?.pgm_grade_level[0])
    }
  }, [programDetail])

  const getActionButton = function () {
    if (readOnlyMode) {
      return null
    } else if (value === 0 && programDetail.pgm_questions) {
      return (
        <Button
          className="custom-info-button text-transform-none"
          size="large"
          variant="contained"
          disableElevation
          color="primary"
          onClick={() => handleChange(null, 1)}
        >
          {t('applicationQuestions')}
        </Button>
      )
    } else if (
      ((value === 0 || value === 1) &&
        (!programDetail.pgm_course_required || programDetail.pgm_courseless) &&
        programDetail.pgm_program_type !== PROGRAM_TYPE.LIBRARY) ||
      (value === 2 && !programDetail?.pgm_attached_pgm)
    ) {
      return (
        <Button
          className="custom-green-button text-transform-none"
          size="large"
          variant="contained"
          disableElevation
          color="primary"
          onClick={addOnsList?.length ? toggleAddOnItemsModal : toggleTermsConditionModal}
          disabled={
            (isEmpty(selectedGrade) &&
              programDetail.pgm_program_type === PROGRAM_TYPE.PROGRAM &&
              !programDetail.pgm_courseless &&
              programDetail.pgm_course_required) ||
            !isEmpty(answerTextError)
          }
        >
          {programMetaData.skip_psm_gateways ? t('proceed') : t('makePayment')}
        </Button>
      )
    } else if (
      (value === 2 && programDetail?.pgm_attached_pgm?.ap_allow_students_view_aop) ||
      ((value === 0 || value === 1) &&
        (!programDetail.pgm_course_required || programDetail.pgm_courseless) &&
        programDetail.pgm_program_type !== PROGRAM_TYPE.LIBRARY)
    ) {
      return (
        <Button
          className="custom-info-button text-transform-none"
          size="large"
          variant="contained"
          disableElevation
          color="primary"
          // onClick={addOnsList?.length ? toggleAddOnItemsModal : toggleTermsConditionModal}
          onClick={() => handleChange(null, 3)}
          disabled={
            (isEmpty(selectedGrade) &&
              programDetail.pgm_program_type === PROGRAM_TYPE.PROGRAM &&
              !programDetail.pgm_courseless &&
              programDetail.pgm_course_required) ||
            !isEmpty(answerTextError)
          }
        >
          {t('addOnPrograms')}
        </Button>
      )
    } else if (
      value === 3 ||
      (value === 2 &&
        programDetail?.pgm_attached_pgm?.ap_allow_students_view_aop &&
        addOnProgramSaved?.length) ||
      ((value === 0 || value === 1) &&
        (!programDetail.pgm_course_required || programDetail.pgm_courseless) &&
        programDetail.pgm_program_type !== PROGRAM_TYPE.LIBRARY &&
        programDetail?.pgm_attached_pgm)
    ) {
      return (
        <>
          <Box display={'flex'}>
            <Box marginRight={1}>
              <Button
                className="custom-info-button text-transform-none"
                size="large"
                variant="contained"
                disableElevation
                color="primary"
                onClick={() =>
                  removeAddOnProgram(programDetail?.pgm_attached_pgm?.ap_pgm_source_id)
                }
                disabled={!addOnProgramSaved?.length}
              >
                {t('removeAddOnProgram')}
              </Button>
            </Box>
            <Button
              className="custom-green-button text-transform-none"
              size="large"
              variant="contained"
              disableElevation
              color="primary"
              onClick={addOnsList?.length ? toggleAddOnItemsModal : toggleTermsConditionModal}
              disabled={
                (isEmpty(selectedGrade) &&
                  programDetail.pgm_program_type === PROGRAM_TYPE.PROGRAM &&
                  !programDetail.pgm_courseless &&
                  programDetail.pgm_course_required) ||
                !isEmpty(answerTextError)
              }
            >
              {programMetaData.skip_psm_gateways ? t('proceed') : t('makePayment')}
            </Button>
          </Box>
        </>
      )
    } else if (value === 2 && !programDetail?.pgm_attached_pgm?.ap_allow_students_view_aop) {
      return (
        <Button
          className="custom-green-button text-transform-none"
          size="large"
          variant="contained"
          disableElevation
          color="primary"
          onClick={addOnsList?.length ? toggleAddOnItemsModal : toggleTermsConditionModal}
          disabled={
            (isEmpty(selectedGrade) &&
              programDetail.pgm_program_type === PROGRAM_TYPE.PROGRAM &&
              !programDetail.pgm_courseless &&
              programDetail.pgm_course_required) ||
            !isEmpty(answerTextError)
          }
        >
          {programMetaData.skip_psm_gateways ? t('proceed') : t('makePayment')}
        </Button>
      )
    } else if (
      (value === 1 || value === 0) &&
      programDetail.pgm_program_type === PROGRAM_TYPE.LIBRARY
    ) {
      return (
        <Button
          className="custom-green-button text-transform-none"
          size="large"
          variant="contained"
          disableElevation
          color="primary"
          onClick={toggleTermsConditionModal}
          disabled={
            programDetail.pgm_program_type === PROGRAM_TYPE.LIBRARY && programDetail.pgm_questions
              ? !isApplicationQustionFilled
              : false
          }
          // disabled={!(programDetail.pgm_program_course_group || []).length}
        >
          {t('continue')}
        </Button>
      )
    } else if (
      (value === 0 || value === 1) &&
      programDetail.pgm_program_type !== PROGRAM_TYPE.LIBRARY &&
      programDetail.pgm_course_required
    ) {
      return (
        <Button
          className="custom-info-button text-transform-none"
          size="large"
          variant="contained"
          disableElevation
          color="primary"
          onClick={() => handleChange(null, 2)}
          disabled={!careerInstructionFormUgly}
        >
          {t('viewCourses')}
        </Button>
      )
    }
  }
  return (
    <>
      {readOnlyMode && (
        <Box
          py={2}
          px={3}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Box className="brand-logo">
            <img
              src={school.sch_logo || ExcelLogo}
              alt="Logo"
              onError={(e) => {
                e.target.onerror = null
                e.target.src = ExcelLogo
              }}
            />
          </Box>

          <Box display="flex" alignItems="center" mt={{ xs: 1, sm: 0 }}>
            <Button
              className="custom-default-button text-transform-none"
              variant="contained"
              disableElevation
              startIcon={<ArrowLeft width={16} height={16} />}
              color="default"
              onClick={() => history.push(getSchoolUrl({ ...params, to: ROUTES.ALLPROGRAMSOPEN }))}
            >
              {t('back')}
            </Button>

            <Box ml={{ xs: 0, sm: 1 }}>
              <Button
                className="text-transform-none"
                variant="contained"
                disableElevation
                color="primary"
                endIcon={<ArrowRight width={16} height={16} />}
                onClick={() =>
                  metadata?.enr_pgm_selection === 'pre-registration'
                    ? enrollProgram(programDetail.pgm_id)
                    : history.push(getSchoolUrl({ ...params, to: ROUTES.REGISTER }))
                }
              >
                {metadata?.enr_pgm_selection === 'pre-registration'
                  ? t('enrollNow')
                  : t('registerNow')}
              </Button>
            </Box>
          </Box>
        </Box>
      )}
      <Box pb={2} pt={!readOnlyMode ? 2 : 0} px={readOnlyMode ? 3 : 0}>
        {!readOnlyMode && <Breadcrumb data={breadcrumbData} />}
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={12} sm="auto">
            <Typography component="h4" align="left" variant="h5" color="textPrimary" tabIndex={0}>
              <Box component="span" fontWeight="700">
                {t('programsDetails')}
              </Box>
            </Typography>
          </Grid>
          {!readOnlyMode ? (
            <Grid item xs={12} sm="auto">
              <Box mt={{ xs: 1, sm: 0 }}>
                <Button
                  className="custom-default-button text-transform-none"
                  size="large"
                  variant="contained"
                  disableElevation
                  startIcon={<ArrowLeft />}
                  color="default"
                  onClick={() =>
                    history.push(getSchoolUrl({ ...params, to: ROUTES.PROGRAMCOURSES }))
                  }
                >
                  {t('back')}
                </Button>
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </Box>
      <Box px={readOnlyMode ? 3 : 0}>
        <Paper rounded="true" elevation={1} className="paper-round">
          <Box className="program-list" width="100%" p={{ xs: 0, sm: 2 }}>
            <Box
              px={{ xs: 2, sm: 0 }}
              pt={{ xs: 2, sm: 0 }}
              pb={2}
              display="flex"
              alignItems="flex-start"
              justifyContent="flex-start"
              flexDirection={{ xs: 'column', sm: 'row' }}
              width="100%"
            >
              <Box className={classes.programImage} width="auto">
                <Box
                  mx="auto"
                  width="112px"
                  height="112px"
                  borderRadius={8}
                  className="image-container"
                >
                  <img
                    src={programDetail.pgm_logo ? programDetail.pgm_logo || '' : UploadImg}
                    onError={(e) => {
                      e.target.onerror = null
                      e.target.src = UploadImg
                    }}
                    alt="program"
                  />
                </Box>
              </Box>

              <Box className={classes.completedProgram} pl={{ xs: 0, sm: 3 }} mt={{ xs: 2, sm: 0 }}>
                <Grid
                  container
                  justifyContent="space-between"
                  direction={breakpoint ? 'column-reverse' : 'row'}
                >
                  <Grid item xs={12} sm="auto">
                    <Typography
                      component="h4"
                      variant="body1"
                      className="word-break"
                      gutterBottom
                      tabIndex={0}
                    >
                      <Box fontWeight={600}>{programDetail.pgm_name}</Box>
                    </Typography>
                    {programReviewSettings[0]?.context_data?.publish_aggregated_ratings &&
                      !isNullOrEmpty(programRatings[0]?.aggregateRating) &&
                      programRatings[0]?.aggregateRating > 0 &&
                      ((readOnlyMode &&
                        programReviewSettings[0]?.context_data?.public_program_detail) ||
                        (!readOnlyMode &&
                          programReviewSettings[0]?.context_data?.program_details)) && (
                        <Box
                          color={'var(--color-star-orange)'}
                          display={'flex'}
                          alignItems={'center'}
                          mt={1}
                          mb={1}
                        >
                          <Star width={24} height={24} />
                          <Typography component="span" variant="body1">
                            <Box fontSize={'16px'} color={'var(--color-grey-1)'} fontWeight={500}>
                              {programRatings[0]?.aggregateRating}
                            </Box>
                          </Typography>
                          <Typography component="span" variant="body1">
                            <Box
                              ml={1}
                              fontSize={'14px'}
                              color={'var(--color-grey-3)'}
                              fontWeight={400}
                            >
                              ({programRatings[0]?.totalRatings} {t('rating')})
                            </Box>
                          </Typography>
                        </Box>
                      )}
                  </Grid>
                  <Grid item xs={12} sm="auto">
                    {programDetail.pgm_enrolled ? (
                      <Box display="flex" flexDirection="column" lignItems="flex-end">
                        <Box
                          mb={1}
                          component="div"
                          display="flex"
                          alignItems="center"
                          tabIndex={0}
                          className="text-info"
                        >
                          <Info width={16} height={16} />
                          <Box component="span" ml={1} fontWeight="500" fontSize="14px">
                            {t('alreadyEnrolled')}
                          </Box>
                        </Box>
                        <Box component="span" textAlign="right">
                          <ButtonEnhanced
                            className="text-transform-none"
                            variant="contained"
                            disableElevation
                            color="primary"
                            to={
                              user?.isProfileCompleted
                                ? ROUTES.ALLENROLLMENTS
                                : ROUTES.UPDATE_PROFILE
                            }
                          >
                            {t('goToEnrollments')}
                          </ButtonEnhanced>
                        </Box>
                      </Box>
                    ) : (
                      getActionButton()
                    )}
                  </Grid>
                </Grid>

                {!readOnlyMode && (
                  <Box mb={1} width="100%">
                    <Box className="label-chip" mt={1}>
                      <Clock height={16} width={16} />
                      <Box ml={1} tabIndex={0}>
                        {t('programDuration') + ' : '}{' '}
                        {programDetail.pgm_expiration === 0
                          ? t('lifeLong')
                          : t('withDay', {
                              days: programDetail.pgm_expiration,
                            })}
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              aria-label="tabs"
              variant="scrollable"
              className="custom-tabs"
            >
              <Tab label={t('programDetails')} value={0} id="userTab-0" tabIndex={0} />
              {!readOnlyMode && programDetail.pgm_questions && (
                <Tab label={t('applicationQuestions')} value={1} id="userTab-1" tabIndex={0} />
              )}
              {(readOnlyMode || programDetail.pgm_course_required) &&
                !programDetail.pgm_courseless &&
                programDetail.pgm_program_type !== PROGRAM_TYPE.LIBRARY && (
                  <Tab
                    label={t('courseCatalog')}
                    id="userTab-2"
                    tabIndex={0}
                    value={2}
                    disabled={
                      !readOnlyMode &&
                      programDetail.pgm_questions &&
                      (value === 0 || (value === 1 && !careerInstructionFormUgly))
                    }
                  />
                )}
              {!readOnlyMode && programDetail?.pgm_attached_pgm?.ap_allow_students_view_aop && (
                <Tab
                  label={t('addOnPrograms')}
                  value={3}
                  id="userTab-3"
                  tabIndex={0}
                  disabled={
                    !readOnlyMode &&
                    ((value === 0 && programDetail?.pgm_questions) ||
                      (value === 1 && !careerInstructionFormUgly))
                  }
                />
              )}
            </Tabs>

            <TabPanel value={value} index={0} dir={theme.direction}>
              <Box px={{ xs: 2, sm: 0 }} pb={{ xs: 2, sm: 0 }} width="100%">
                <Box mt={1} width="100%">
                  <Typography
                    component="h6"
                    align="left"
                    variant="subtitle2"
                    color="textPrimary"
                    className="word-break"
                    tabIndex={0}
                  >
                    {programDetail?.pgm_short_description ? (
                      <Box component="span" fontWeight="600" fontSize="13px">
                        {programDetail?.pgm_short_description}
                      </Box>
                    ) : (
                      <Box className="icon-color-light" fontSize="13px" fontWeight="500">
                        {t('notAvailable')}
                      </Box>
                    )}
                  </Typography>
                </Box>
                <Box mt={1} width="100%">
                  <Typography
                    component="h6"
                    align="left"
                    variant="subtitle2"
                    color="textPrimary"
                    className="word-break"
                    tabIndex={0}
                  >
                    <Box
                      component="span"
                      dangerouslySetInnerHTML={{
                        __html: programDetail.pgm_description,
                      }}
                      fontWeight="fontWeightRegular"
                      fontSize="14px"
                    ></Box>
                  </Typography>
                </Box>
                {programDetail.pgm_show_prerequisites && (
                  <Box mt={1} width="100%">
                    <Typography component="h6" align="left" variant="h6" tabIndex={0}>
                      <Box component="span" fontWeight="600" fontSize="14px">
                        {t('preRequisite')}
                      </Box>
                    </Typography>
                    <Typography
                      component="h6"
                      align="left"
                      variant="subtitle2"
                      color="textPrimary"
                      className="word-break"
                      tabIndex={0}
                    >
                      <Box component="span" fontWeight="fontWeightRegular" fontSize="14px">
                        <div
                          tabIndex={0}
                          dangerouslySetInnerHTML={{
                            __html: programDetail?.pgm_prerequisites,
                          }}
                        ></div>
                      </Box>
                    </Typography>
                  </Box>
                )}
              </Box>
            </TabPanel>
            {!readOnlyMode && (
              <TabPanel value={value} index={1} dir={theme.direction}>
                <CareerForm
                  careerInstructionQuestion={careerInstructionQuestion}
                  setCareerInstructionQuestion={setCareerInstructionQuestion}
                  answerTextError={answerTextError}
                  setAnswerTextError={setAnswerTextError}
                />
                {!programDetail.pgm_enrolled && (
                  <Box display="flex" flexDirection="column" alignItems="flex-end">
                    {getActionButton()}
                  </Box>
                )}
              </TabPanel>
            )}
            {!programDetail.pgm_courseless && (
              <TabPanel value={value} index={2} dir={theme.direction}>
                <CoursesList
                  allHeadCells={allHeadCells}
                  programDetail={programDetail}
                  readOnlyMode={readOnlyMode}
                  pgmEnrolled={programDetail.pgm_enrolled}
                  selectedGrade={selectedGrade}
                  toggleCurrentGrade={toggleCurrentGrade}
                  courseList={courseList}
                  setCourseList={setCourseList}
                />
              </TabPanel>
            )}
            {programDetail?.pgm_attached_pgm && (
              <TabPanel value={value} index={3} dir={theme.direction}>
                <AddOnPrograms
                  addOnProgramDetailToggle={addOnProgramDetailToggle}
                  programRatings={programRatings}
                  programDetail={programDetail}
                  readOnlyMode={readOnlyMode}
                  addOnProgramQuestions={addOnProgramQuestions}
                  answerTextError={answerTextError}
                  setAnswerTextError={setAnswerTextError}
                  addOnProgramRatings={addOnProgramRatings}
                  addOnProgramReviewSettings={addOnProgramReviewSettings}
                  saveAddOnProgram={saveAddOnProgram}
                  addOnProgramSaved={addOnProgramSaved}
                  removeAddOnProgram={removeAddOnProgram}
                />
              </TabPanel>
            )}
          </Box>
        </Paper>
      </Box>
      <AgeRequirement
        onClose={toggleAgeRequirementModal}
        open={ageRequirement}
        programDetail={programDetail}
      />
      <TermsConditions
        onClose={toggleTermsConditionModal}
        open={termsCondition}
        enrollCourse={enrollCourse}
        programDetail={programDetail}
        termCondition={termCondition}
        school={school}
        selectedGrade={selectedGrade}
        selectedGradeAddOnProgram={selectedGradeAddOnProgram}
      />

      <AddOnPurchaseItems
        onClose={toggleAddOnItemsModal}
        open={addOnsModal}
        addOnsList={addOnsList}
        selectedAddOnItems={selectedAddOnItems}
        setSelectedAddOnItems={setSelectedAddOnItems}
        onProceed={toggleTermsConditionModal}
      />
      <AddOnProgramDetail
        allHeadCells={allHeadCells}
        attachedProgramDetail={attachedProgramDetail}
        readOnlyMode={readOnlyMode}
        pgmEnrolled={attachedProgramDetail.pgm_enrolled}
        selectedGrade={selectedGrade}
        courseList={attachedProgramCoursesList}
        setCourseList={setAttachedProgramCoursesList}
        programDetail={programDetail}
        open={addOnProgramDetail}
        onClose={addOnProgramDetailToggle}
        addOnProgramQuestions={addOnProgramQuestions}
        setAddOnProgramQuestions={setAddOnProgramQuestions}
        answerTextError={answerTextError}
        setAnswerTextError={setAnswerTextError}
        addOnsList={addOnsList}
        toggleAddOnItemsModal={toggleAddOnItemsModal}
        toggleTermsConditionModal={toggleTermsConditionModal}
        saveAddOnProgram={saveAddOnProgram}
        addOnProgramSaved={addOnProgramSaved}
        addOnProgramDetailToggle={addOnProgramDetailToggle}
        addOnProgramDetail={addOnProgramDetail}
        handleAddOnProgramTabChange={handleAddOnProgramTabChange}
        addOnProgramTabValue={addOnProgramTabValue}
        addOnProgramQuestionsUgly={addOnProgramQuestionsUgly}
        toggleGradeAddOnProgram={toggleGradeAddOnProgram}
        selectedGradeAddOnProgram={selectedGradeAddOnProgram}
      />
    </>
  )
}
AvailableProgramDetail.propTypes = {
  allHeadCells: PropTypes.array,
  allHeadCellsCore: PropTypes.array,
  programDetail: PropTypes.object,
  enrollCourse: PropTypes.func,
  ageRequirement: PropTypes.bool,
  toggleAgeRequirementModal: PropTypes.func,
  termCondition: PropTypes.string,
  value: PropTypes.number,
  handleChange: PropTypes.func,
  school: PropTypes.object,
  readOnlyMode: PropTypes.bool,
  enrollProgram: PropTypes.func,
  careerInstructionQuestion: PropTypes.array,
  setCareerInstructionQuestion: PropTypes.func,
  careerInstructionFormUgly: false,
  handleRuleValidation: PropTypes.func,
  user: PropTypes.object,
  courseList: PropTypes.array,
  setCourseList: PropTypes.func,
  programRatings: PropTypes.array,
  programReviewSettings: PropTypes.array,
  addOnsList: PropTypes.array,
  selectedAddOnItems: PropTypes.array,
  setSelectedAddOnItems: PropTypes.func,
  attachedProgramDetail: PropTypes.object,
  addOnProgramQuestions: PropTypes.array,
  addOnProgramRatings: PropTypes.array,
  addOnProgramReviewSettings: PropTypes.array,
  setAttachedProgramCoursesList: PropTypes.func,
  attachedProgramCoursesList: PropTypes.array,
  setAddOnProgramQuestions: PropTypes.func,
  saveAddOnProgram: PropTypes.func,
  addOnProgramDetailToggle: PropTypes.func,
  addOnProgramDetail: PropTypes.bool,
  addOnProgramSaved: PropTypes.array,
  removeAddOnProgram: PropTypes.func,
  addOnProgramTabValue: PropTypes.number,
  handleAddOnProgramTabChange: PropTypes.func,
  addOnProgramQuestionsUgly: PropTypes.bool,
  programMetaData: PropTypes.object,
  metadata: PropTypes.object,
}

AvailableProgramDetail.defaultProps = {
  allHeadCells: [],
  allHeadCellsCore: [],
  programDetail: {},
  enrollCourse: noop,
  setProgramDetail: noop,
  ageRequirement: false,
  toggleAgeRequirementModal: noop,
  termCondition: '',
  value: 0,
  handleChange: noop,
  school: {},
  readOnlyMode: false,
  enrollProgram: noop,
  careerInstructionQuestion: [],
  setCareerInstructionQuestion: noop,
  careerInstructionFormUgly: false,
  handleRuleValidation: noop,
  user: {},
  courseList: [],
  setCourseList: noop,
  programRatings: noop,
  programReviewSettings: [],
  addOnsList: [],
  selectedAddOnItems: [],
  setSelectedAddOnItems: noop,
  attachedProgramDetail: {},
  addOnProgramQuestions: [],
  addOnProgramRatings: [],
  addOnProgramReviewSettings: [],
  setAttachedProgramCoursesList: noop,
  attachedProgramCoursesList: [],
  setAddOnProgramQuestions: noop,
  saveAddOnProgram: noop,
  addOnProgramDetailToggle: noop,
  addOnProgramDetail: false,
  addOnProgramSaved: [],
  removeAddOnProgram: noop,
  addOnProgramTabValue: 0,
  handleAddOnProgramTabChange: noop,
  addOnProgramQuestionsUgly: false,
  programMetaData: {},
  metadata: {},
}

export default AvailableProgramDetail
